import { MantyStatus } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';

export const INDICIAIRE_STATUSES = [
    MantyStatus.CONTRACTOR,
    MantyStatus.SUBSTITUTE_CONTRACTOR,
    MantyStatus.WAITING_FOR_TITULAIRE_CONTRACTOR,
    MantyStatus.TITULAIRE,
    MantyStatus.FONCTIONNAIRE_STAGIAIRE,
];

export const NON_INDICIAIRE_STATUSES = [
    MantyStatus.VACATAIRE,
    MantyStatus.SEASONAL_CONTRACTOR,
    MantyStatus.APPRENTICE,
    MantyStatus.ACTIVITY_INCREASE_CONTRACTOR,
    MantyStatus.EMPLOI_AIDE,
    MantyStatus.ASSISTANTE_MATERNELLE,
];
